import {Injectable} from '@angular/core';
import {FnApplication} from './fn-application';

@Injectable()
export class FnApplicationHelper {

  public fnApplication: FnApplication;

  setApplication(fnApplication: FnApplication) {
    this.fnApplication = fnApplication;
  }

  getApplication() {
    return this.fnApplication;
  }
}
